import { http } from "@/core/api/";

const apiUrl = "api/signature";
export default {
  getAvailablePositions(groupId) {
    return http.get(`${apiUrl}/availablepositions?group=${groupId}`);
  },
  getPreRegisterSignatureTypes() {
    return http.get(`${apiUrl}/getsignaturetypes/false`);
  },
  getPostRegisterSignatureTypes() {
    return http.get(`${apiUrl}/getsignaturetypes/true`);
  },
  saveStudentTutorSignature(payload) {
    return http.post(`${apiUrl}/saveSignature`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  getAllSignatureTypes() {
    return http.get(`${apiUrl}/getallsignaturetypes`);
  },
  getSignatureTabIsEnabled() {
    return http.get(`/api/pei/signaturetabisenabled`);
  },
  createDigitalSignatureDocument(payload) {
    return http.post(`/api/pei/createdigitalsignature`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async getDigitalSignatureDocument(pei) {
    return await http.get(`/api/pei/digitalsignturedocument/${pei}`);
  },
  sendEmail(email, name, documentId) {
    return http.get(`/api/pei/sendemail/${email}/${name}/${documentId}`);
  },
  updateEmail(documentId, userid, email) {
    return http.get(`/api/pei/updateemail/${documentId}/${userid}/${email}`);
  },
  getLinkDigitalSignture(documentId) {
    return http.get(`/api/pei/digitalsignaturelink/${documentId}`);
  },
  getDocumentCancellationDetail(peiId) {
    return http.get(`/api/pei/documentcancellationdetail/${peiId}`);
  },
  getAtServiceDocuments(peiId) {
    return http.get(`/api/pei/${peiId}/atservicedocuments`);
  }
};
